import {
  APP_SET_TIMEZONE_DATA,
  APP_SET_TIMEZONE_LOADING,
  APP_SET_SIDEBAR,
  APP_SET_STICKY_FILTERS,
  APP_SET_FILTERS_TOGGLE_METHOD,
} from './enums/appTypes';

const initialState = {
  timezoneData: [],
  timezoneLoading: false,
  sidebarShow: 'responsive',
  stickyFilters: false, // Show sticky filters button on top sticky bar on Dashboars. Fired from FiltersSummaryComponent
  fltersToggleMethod: null, // Dashboard filters toggle method
};

const DivisionReducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_SET_TIMEZONE_DATA:
      return { ...state, timezoneData: action.data, timezoneLoading: false };
    case APP_SET_TIMEZONE_LOADING:
      return { ...state, timezoneLoading: action.value };
    case APP_SET_SIDEBAR:
      return { ...state, sidebarShow: action.value };
    case APP_SET_STICKY_FILTERS:
      return { ...state, stickyFilters: action.value };
    case APP_SET_FILTERS_TOGGLE_METHOD:
      return { ...state, fltersToggleMethod: action.method };
    default:
      return state;
  }
};
export default DivisionReducer;
